module.exports = __webpack_public_path__ + "static/media/nail-background.ef62adbc.jpg";